import Vue from 'vue'

window._eventHub = Vue.prototype.$eventHub = new Vue()
